export default __webpack_public_path__ + "static/media/Discord-Logo-White.9a823ca6.svg";